import { render, staticRenderFns } from "./StrategiesDesigner.vue?vue&type=template&id=20b81560&"
import script from "./StrategiesDesigner.vue?vue&type=script&lang=js&"
export * from "./StrategiesDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports